import { z } from 'src/lib'
import { OperacionWRCFields } from './fields'

export const schemaFormOperacionWRC = z.object({
    [OperacionWRCFields.CodSectorComercial]: z.number(),
    [OperacionWRCFields.NroComitente]: z.string(),
    [OperacionWRCFields.DenominacionComitente]: z.string(),
    [OperacionWRCFields.Observaciones]: z.string().optional(),
    [OperacionWRCFields.FechaEmision]: z.date(),
    [OperacionWRCFields.FechaVencimiento]: z.date()
})

export type FormOperacionWRC = z.infer<typeof schemaFormOperacionWRC>
